<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item label="课程名称">
              <a-input
                placeholder="请输入课程名称"
                v-model="searchObj.subjectName"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="上架栏目">
              <a-tree-select
                ref="notice"
                :tree-data="columnChannel"
                placeholder="请选择发布渠道栏目"
                @change="onColumnChange"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px" >重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('exportXlsUrl','课程管理')">全部导出</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="2" @click="batchReview"><a-icon type="check"/>批量审核</a-menu-item>
          <a-menu-item key="1" @click="batchPut"><a-icon type="snippets"/>批量发布</a-menu-item>
          <a-menu-item key="3" @click="handleExportXls('exportXlids','课程管理')"><a-icon type="download"/>选择导出</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <span slot="nameAction" slot-scope="text, record">
          <a @click="directoryItem(record)" > {{record.subjectName}}</a>
        </span>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />

          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item v-if="record.status == 1">
                <a-popconfirm title="确定提交审核吗?" @confirm="() => handleSubmit(record.id)">
                  <a>提交</a>
                </a-popconfirm>
              </a-menu-item>

              <a-menu-item v-if="record.status == 2">
                <a href="javascript:;" @click="handleReview(record.id)">审核</a>
              </a-menu-item>

              <a-menu-item v-if="record.status == 3">
                <a-popconfirm title="确定发布吗?" @confirm="() => handlePublish(record.id)">
                  <a>发布</a>
                </a-popconfirm>
              </a-menu-item>

              <a-menu-item v-if="record.status == 4">
                <a-popconfirm title="确定下架吗?" @confirm="() => handleOffShelf(record.id)">
                  <a>下架</a>
                </a-popconfirm>
              </a-menu-item>

              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>

            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
      <!--  文章审核-->
      <a-modal
        title="审核"
        :visible="showReview"
        :width="800"
        @cancel="showReview = false"
        @ok="handalExamine">

        <a-radio-group v-model="examineFlg" @change="examineFlgChange">
          <a-radio :value="1">审核通过</a-radio>
          <a-radio :value="2">审核驳回</a-radio>
        </a-radio-group>

        <a-textarea
          style="margin-top: 20px"
          placeholder="请输入理由"
          v-model="reason"
          :max-length="100"
          :auto-size="{ minRows: 2, maxRows: 6 }"/>
      </a-modal>
      <a-modal
        title="批量审核"
        :visible="batchReviewModel.showReview"
        :width="800"
        @cancel="batchReviewModel.showReview = false"
        @ok="batchHandalExamine">

        <a-radio-group v-model="batchReviewModel.examineFlg" @change="batchExamineFlgChange">
          <a-radio :value="1">审核通过</a-radio>
          <a-radio :value="2">审核驳回</a-radio>
        </a-radio-group>
        <a-textarea
          style="margin-top: 20px"
          placeholder="请输入理由"
          v-model="batchReviewModel.reason"
          :max-length="100"
          :auto-size="{ minRows: 2, maxRows: 6 }"/>
      </a-modal>
    </div>

    <cm-sm-subject-modal :columnChannel="columnChannel" ref="modalForm" @ok="modalFormOk"></cm-sm-subject-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { filterObj } from '@/utils/util';
  import CmSmSubjectModal from './modules/CmSmSubjectModal'
  import { getAction, postAction, downFile } from '@/api/manage';
  import {initDictOptions,filterDictTextByCache} from '@/components/dict/JDictSelectUtil';
  import { findTreeNodeArray } from '@/utils/common';
  const columns = [
    {
      title: '序号',
      dataIndex: '',
      key:'rowIndex',
      width:60,
      align:"center",
      customRender:function (t,r,index) {
        return parseInt(index)+1;
      }
    },
    {
      title:'课程名称',
      align:"center",
      dataIndex: 'subjectName',
      scopedSlots: { customRender: 'nameAction' }
    },
    {
      title:'上架渠道栏目',
      align:"center",
      dataIndex: 'columnName',
      customRender: (text,record) => {

        return (record.channelName||"")+"|"+text||'--';
      }
    },
    {
      title:'创建时间',
      align:"center",
      dataIndex: 'createTime',
      customRender:function (text) {
        return !text?"":(text.length>10?text.substr(0,10):text)
      }
    },
    {
      title:'发布时间',
      align:"center",
      dataIndex: 'publishTime',
      customRender:function (text) {
        return !text?"":(text.length>10?text.substr(0,10):text)
      }
    },
    {
      title:'子课程数量',
      align:"center",
      dataIndex: 'totalChapter'
    },
    {
      title:'学习人数',
      align:"center",
      dataIndex: 'totalStudyNumber'
    },
    {
      title:'点赞数',
      align:"center",
      dataIndex: 'totalLikes'
    },
    {
      title:'订阅数',
      align:"center",
      dataIndex: 'totalSubscribe'
    },
    {
      title:'发布状态',
      align:"center",
      dataIndex: 'status',
      customRender:function (text) {
        return filterDictTextByCache('course_status',text);
      }
    },
    {
      title:'审核意见',
      align:"center",
      dataIndex: 'refuseReason'
    },
    {
      title: '操作',
      dataIndex: 'action',
      align:"center",
      fixed:"right",
      width:147,
      scopedSlots: { customRender: 'action' }
    }
  ];
  export default {
    name: 'CmSmSubjectList',
    components: {
      CmSmSubjectModal
    },
    data () {
      return {
        description: '课程管理页面',
        //--------列表页重复代码 start-------------
        searchObj: {
          subjectName: undefined,
          columnCode: undefined
        },
        /* table选中keys*/
        selectedRowKeys: [],
        loading: false,
        queryParam: {
          custType: '',
          realName: ''
        },
        dataSource: [],
        ipagination: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + '-' + range[1] + ' 共' + total + '条';
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        columnChannel: [],
        // 表头
        columns,
        url: {
          list: process.env.VUE_APP_CMS_CONTENT+"/subject/cmSmSubject/list",
          delete: process.env.VUE_APP_CMS_CONTENT+"/subject/cmSmSubject/delete",
          exportXlsUrl: process.env.VUE_APP_CMS_CONTENT+"/subject/cmSmSubject/exportXls",
          exportXlids: process.env.VUE_APP_CMS_CONTENT+"/subject/cmSmSubject/exportXlids",
          updateStatus: process.env.VUE_APP_CMS_CONTENT + "/subject/cmSmSubject/updateStatusById",
          updateReview: process.env.VUE_APP_CMS_CONTENT + "/subject/cmSmSubject/updateReviewById",
          batchReview: process.env.VUE_APP_CMS_CONTENT + '/subject/cmSmSubject/updateReview/batch',//批量审核
          batchPublish: process.env.VUE_APP_CMS_CONTENT + '/subject/cmSmSubject/updateStatus/batch',//批量发布
        },

        showReview: false, //审核弹窗
        examineFlg: 1, //1-审核通过 2-审核拒绝
        currentResviewId: "",//当前要审核id
        reason: '', //审核拒绝理由
        batchReviewModel:{
          showReview: false, //审核弹窗
          examineFlg: 1, //1-审核通过 2-审核拒绝
          reason: '', //审核拒绝理由
        },
      }
    },
    created() {
      this.initData();
      this.loadData(1);
      this.initDictConfig();
    },
    methods: {
      initDictConfig() {
        //初始化字典

      },
      onColumnChange(id){
          let arr = findTreeNodeArray('children', this.columnChannel, e => {
            return id == e.id;
          });
          if(arr.length>0){
            this.searchObj.columnCode = arr[0].code;
          }else{
            this.searchObj.columnCode = "";
          }
      },
      directoryItem(record) {
        //课程点击查看目录
        //this.$refs.directoryForm.initEditDirectory(record.id);
        this.$router.push({
          path: '/contentManage/directoryManage/directoryManageList',
          query: { id: record.id },
        });
      },
      handleSubmit(id){
        console.log("提交");
        //2 待审核
        this._handleStatus(id,"2","已提交为待审核！")
      },
      handleReview(id){
        console.log("审核");
        this.showReview = true;
        this.currentResviewId = id;
      },
      handalExamine() {//审核结果提交
        if (this.examineFlg == '') {
          this.$message.warning('请选你要审核的状态');
        }
        postAction(this.url.updateReview, {
          id: this.currentResviewId,
          isReview:this.examineFlg,
          refuseReason: this.reason == '' ? null : this.reason
        }).then(res => {
          if (res.success) {
            this.showReview = false;
            this.loadData(1);
            this.reason = '';
            this.$message.success(this.examineFlg==1?"已审核通过":"已审核拒绝");
          } else {
            this.$message.error(res.message);
          }
        });

      },
      examineFlgChange(e) {//审核通过和不通过选择
        this.examineFlg = e.target.value;
      },
      handlePublish(id){
        console.log("发布");
        this._handleStatus(id,"4","发布成功！")
      },
      handleOffShelf(id){
        console.log("下架");
        this._handleStatus(id,"3","下架成功！")
      },
      _handleStatus(id,status,msg){
        let that = this;
        that.loading = true;
        postAction(this.url.updateStatus,{id:id,status:status}).then(res => {
          if (res.success) {
            that.$message.success(msg);
            that.loadData(1);
          } else {
            that.$message.error(res.message);
          }
        }).finally(() => {
          that.loading = false;
        });
      },
      batchReview(){
        //批量审核
        console.log("批量审核");
        for (let i = 0; i < this.selectionRows.length; i++) {
          let row = this.selectionRows[i];
          if(row.status != 2){
            this.$message.error("存在除待审核外其他状态的数据，不能进行批量审核");
            return;
          }
        }
        this.batchReviewModel.showReview = true;
      },
      batchExamineFlgChange(e) {//审核通过和不通过选择
        this.batchReviewModel.examineFlg = e.target.value;
      },
      batchHandalExamine() {//审核结果提交
        if (this.batchReviewModel.examineFlg == '') {
          this.$message.warning('请选你要审核的状态');
        }
        postAction(this.url.batchReview, {
          ids: this.selectedRowKeys.join(','),
          isReview:this.batchReviewModel.examineFlg,
          refuseReason: this.batchReviewModel.reason == '' ? null : this.batchReviewModel.reason
        }).then(res => {
          if (res.success) {
            this.batchReviewModel.showReview = false;
            this.loadData(1);
            this.batchReviewModel.reason = '';
            this.$message.success(this.examineFlg==1?"已批量审核通过":"已批量审核拒绝");
          } else {
            this.$message.error(res.message);
          }
        });

      },
      batchPut(){
        //批量发布
        console.log("批量发布");
        for (let i = 0; i < this.selectionRows.length; i++) {
          let row = this.selectionRows[i];
          if(row.status != 3){
            this.$message.error("存在除待发布外其他状态的数据，不能进行批量发布");
            return;
          }
        }
        let that = this;
        postAction(this.url.batchPublish,{ids:this.selectedRowKeys.join(','),status:"4"}).then(res => {
          if (res.success) {
            that.$message.success("批量发布成功");
            that.loadData(1);
          } else {
            that.$message.error(res.message);
          }
        }).finally(() => {
          that.loading = false;
        });
      },
      initData() {
        getAction(
          process.env.VUE_APP_CMS_CONTENT + '/content/column/queryByChannel',
          { channelCode: 'shangzheng_xuetang' }
        ).then(res => {
          if (res.success) {
            this.columnChannel = res.result;
          }
        });
      },
      //-----------------列表页重复代码-开始--------------
      handleExportXls(exportXlsUrlName,fileName) {
        if (!fileName || typeof fileName != 'string') {
          fileName = '导出文件';
        }
        let param = { ...this.searchObj };
        let idParam = ""
        if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
          param['ids'] = this.selectedRowKeys.join(',');
          idParam = `?ids=${param.ids}`;
        }
        console.log('导出参数', param);
        downFile(this.url[exportXlsUrlName] + idParam, param).then(data => {
          if (!data) {
            this.$message.warning('文件下载失败');
            return;
          }
          if (typeof window.navigator.msSaveBlob !== 'undefined') {
            window.navigator.msSaveBlob(
              new Blob([data], { type: 'application/vnd.ms-excel' }),
              fileName + '.xls'
            );
          } else {
            let url = window.URL.createObjectURL(
              new Blob([data], { type: 'application/vnd.ms-excel' })
            );
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', fileName + '.xls');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link); //下载完成移除元素
            window.URL.revokeObjectURL(url); //释放掉blob对象
          }
        });
      },
      //分页
      handleTableChange(pagination, filters, sorter) {
        this.onClearSelected(); //分页切换时清空表格选中
        //分页、排序、筛选变化时触发
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
        }
        this.ipagination = pagination;
        this.loadData();
      },
      loadData(arg) {
        let that = this;
        if (arg === 1) {
          that.ipagination.current = 1;
        }
        let params = this.getQueryParams();
        getAction(this.url.list,params).then(res => {
          that.loading = true;
          if (res.success) {
            that.dataSource =
              res.result && res.result.records ? res.result.records : [];
            //额外处理start
            this.dataSource.forEach(item => {
              item.statusFlg = item.status == 0 ? true : false;
            });
            //额外处理end
            that.loading = false;
            that.ipagination.total = res.result.total;
          }
        });
      },
      getQueryParams() {
        let param = Object.assign(
          this.searchObj
        );

        param.field = this.getQueryField();
        param.pageNo = this.ipagination.current;
        param.pageSize = this.ipagination.pageSize;
        return filterObj(param);
      },
      getQueryField() {
        let str = 'id,';
        this.columns.forEach(function(value) {
          str += ',' + value.dataIndex;
        });
        return str;
      },
      handleAdd: function() {
        this.$refs.modalForm.add();
        this.$refs.modalForm.title = '新增';
        this.$refs.modalForm.disableSubmit = false;
      },
      handleEdit: function(record) {
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title = '编辑';
        this.$refs.modalForm.disableSubmit = false;
      },
      handleDelete: function(id) {
        if (!this.url.delete) {
          this.$message.error('请设置url.delete属性!');
          return;
        }
        let that = this;
        postAction(that.url.delete, { id: id }).then(res => {
          if (res.success) {
            that.$message.success(res.message);
            that.loadData();
          } else {
            that.$message.warning(res.message);
          }
        });
      },
      modalFormOk() {
        // 新增/修改 成功时，重载列表
        this.loadData();
      },
      onSelectChange(selectedRowKeys, selectionRows) {
        this.selectedRowKeys = selectedRowKeys;
        this.selectionRows = selectionRows;
        console.log(this.name);
        if (this.name == 'courseManageModal') {
          let courseList = selectedRowKeys;
          this.form.setFieldsValue({
            courseList
          });
        }
      },
      onClearSelected() {
        this.selectedRowKeys = [];
        this.selectionRows = [];
      },
      searchQuery() {
        this.loadData(1);
      },
      //重置
      searchReset() {
        this.searchObj = {};
        this.loadData(1);
      }
      //-----------------列表页重复代码-结束--------------
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>